import  Axios  from 'axios';

export const getAxios=()=>{

    return Axios.create({
        baseURL:"https://api.admin.electronicsteps.ir/",
        headers: {
            "x-auth-token" : `${localStorage.getItem("electronicStepsAdmin")}`,
            "Access-Control-Allow-Origin":'*'
        }
    });
};